import { Box, Button } from "@mui/material";
function ResumePage() {
    const handleDownload = () => {
    const link = document.createElement('a');
    link.href = 'Thirupathi Thangavel Resume.pdf'; 
    link.download = 'Thirupathi Thangavel Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    };

  return (
<Box sx={{ maxWidth: 700, mx: "auto", p: 2 }}>
  {/* Right-aligned button */}
  <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
    <Button
      variant="contained"
      startIcon={<DownloadIcon />}
      onClick={handleDownload}
      size="large"
    >
      Download Resume
    </Button>
  </Box>

  {/* Scrollable container */}
  <Box
    sx={{
      height: "80vh",
      overflow: "hidden",
      borderRadius: 2,
      border: "1px solid #ddd"
    }}
  >
    <iframe
      title="resume"
      src="/Thirupathi Thangavel Resume.pdf"
      width="100%"
      height="100%"
      style={{
        border: "none"
      }}
    />
  </Box>
</Box>
  );
}

// Simple Download Icon Component
function DownloadIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="7 10 12 15 17 10"></polyline>
      <line x1="12" y1="15" x2="12" y2="3"></line>
    </svg>
  );
}
export default ResumePage;